import React from 'react';
import { Text, Stack, AnimationStyles, makeStyles } from '@fluentui/react';
import { useMobile } from '../../../../useMobile';
import { mobileConstants } from '../../../../mobileConstants';
import { useMobileContext } from '../../../../MobileContext';
import { useNavigate } from 'react-router';
import { UserRegistrationPeriod } from '../../../../../api/generated/data-contracts';

export const TaskRow: React.FC<{
    task: UserRegistrationPeriod;
}> = props => {
    const history = useNavigate();
    const mobCtx = useMobileContext();
    const classes = getStyles();

    const onEditTask = () => {
        useMobile.getState().addTask({
            setEditTask: true,
            expand: true,
            newTask: props.task,
        });
        mobCtx.isFirstOpenAfterProjectsOverview.current = true;
        // history.push('/');
        history('/', {
            // pathname: '/',
            state: {
                fromProjectsOverview: true,
            },
        });
    };

    return (
        <Stack horizontal verticalAlign="center" className={classes.root} onClick={onEditTask}>
            <Text className={classes.title}>{props.task.taskName}</Text>
        </Stack>
    );
};
const getStyles = makeStyles(theme => ({
    root: {
        ...AnimationStyles.fadeIn200,
        height: mobileConstants.gridRowHeight,
        paddingLeft: 66,
        paddingRight: 16,
        overflowX: 'hidden',
    },
    title: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        minWidth: 100,
        '.isDarkmode &': {
            color: `${theme.semanticColors.bodySubtext} !important`,
        },
    },
}));
